<template functional>
  <hr class="ce-div" />
</template>
<script>
export default {
  name: 'CeDiv',
  functional: true
}
</script>
